import React, { useEffect, useRef, useState } from "react";
import "./AdminPage.css";
import AdminModal from "./AdminModal";

function AdminPage() {
  const canvasRef = useRef(null);
  const particles = useRef([]);

  const [staff, setStaff] = useState([
    { id: 1, name: "Mario Rossi", role: "Consulenza Aziendale", bookings: [{id:101,name:"Cliente A",date:"2025-09-25"}] },
    { id: 2, name: "Luisa Bianchi", role: "Supporto Tecnico", bookings: [{id:102,name:"Cliente B",date:"2025-09-28"}] },
    { id: 3, name: "Giovanni Verdi", role: "Sviluppo Software", bookings: [{id:103,name:"Cliente C",date:"2025-09-30"}] },
  ]);

  const [activeStaff, setActiveStaff] = useState(null);

  const deleteBooking = (staffId, bookingId) => {
    setStaff(prev => prev.map(s => {
      if(s.id === staffId) {
        return {...s, bookings: s.bookings.filter(b => b.id !== bookingId)};
      }
      return s;
    }));
  };

  const addBooking = (staffId, date) => {
    if(!date) return;
    setStaff(prev => prev.map(s => {
      if(s.id === staffId) {
        const nextId = Math.max(0, ...s.bookings.map(b=>b.id)) + 1;
        return {...s, bookings: [...s.bookings, {id: nextId, name:"Nuovo slot", date}]};
      }
      return s;
    }));
  };

  // Particles Background
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    function resize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }
    window.addEventListener("resize", resize);

    const numParticles = 80;
    particles.current = Array.from({ length: numParticles }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      radius: Math.random() * 2 + 1,
      speedX: (Math.random() - 0.5) * 0.5,
      speedY: (Math.random() - 0.5) * 0.5,
      color: `rgba(255,255,255,${Math.random() * 0.5 + 0.3})`
    }));

    function animate() {
      ctx.clearRect(0, 0, width, height);
      particles.current.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;

        if (p.x < 0) p.x = width;
        if (p.x > width) p.x = 0;
        if (p.y < 0) p.y = height;
        if (p.y > height) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });
      requestAnimationFrame(animate);
    }

    animate();
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="admin-page">
      <canvas ref={canvasRef} className="particles-canvas"></canvas>

      <header className="header">
        <div className="logo">
          <img src="logo.png" alt="MA Software Logo" />
          <span>MA Software</span>
        </div>
        <a href="/" className="menu-btn">Home</a>
      </header>

      <main className="admin-main">
        <h1>Gestione Appuntamenti</h1>
        <p>Clicca sul responsabile per aprire il pannello CRUD.</p>

        <div className="booking-cards">
          {staff.map(s => (
            <div key={s.id} className="booking-card" onClick={() => setActiveStaff(s)}>
              <h3>{s.name}</h3>
              <p>{s.role}</p>
            </div>
          ))}
        </div>

        {activeStaff && (
          <AdminModal
            isOpen={!!activeStaff}
            onClose={() => setActiveStaff(null)}
            staff={activeStaff}
            onDeleteBooking={deleteBooking}
            onAddBooking={addBooking}
          />
        )}
      </main>

      <footer className="footer">
        <p>© 2025 MA Software - Tutti i diritti riservati</p>
      </footer>
    </div>
  );
}

export default AdminPage;
